import { render, staticRenderFns } from "./procedure-detail-header.vue?vue&type=template&id=7e7a6ef8&"
import script from "./procedure-detail-header.vue?vue&type=script&lang=js&"
export * from "./procedure-detail-header.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports